<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";
    import ArrowHeadIcon from "@components/icons/ArrowHeadIcon.svelte";

    export let hasNext = true;
    export let hasPrev = true;
    const dispatch = createEventDispatcher();
    const handleNextSlide = (): void => {
        dispatch("nextSlide");
    };
    const handlePrevSlide = (): void => {
        dispatch("prevSlide");
    };
</script>

<div class="gw-rv-gallery-image-slider-arrows">
    {#if hasPrev}
        <BaseButton
            ariaLabel="Previous review images slide"
            class="gw-rv-gallery-image-slider-arrows__arrow gw-rv-gallery-image-slider-arrows__arrow--prev"
            on:click={handlePrevSlide}
        >
            <Icon width={20} height={20}>
                <ArrowHeadIcon />
            </Icon>
        </BaseButton>
    {/if}
    {#if hasNext}
        <BaseButton
            ariaLabel="Next review images slide"
            class="gw-rv-gallery-image-slider-arrows__arrow gw-rv-gallery-image-slider-arrows__arrow--next"
            on:click={handleNextSlide}
        >
            <Icon
                class="gw-rv-gallery-image-slider-arrows__icon"
                width={20}
                height={20}
            >
                <ArrowHeadIcon />
            </Icon>
        </BaseButton>
    {/if}
</div>

<style lang="postcss" global>
    .gw-rv-gallery-image-slider-arrows {
        --gw-dark-bg-opacity: rgba(51, 51, 51, 0.8);
        --gw-dark-bg-opacity-hover: rgba(51, 51, 51, 1);

        & .gw-btn.gw-rv-gallery-image-slider-arrows__arrow {
            display: flex;
            position: absolute;
            top: 50%;
            padding: 6px;
            transform: translateY(-50%);
            border-radius: 5px;
            background: var(--gw-dark-bg-opacity);
            color: var(--gw-white-text-color);

            &--prev {
                left: 10px;
                transform: translateY(-50%) rotateZ(180deg);
            }

            &--next {
                right: 10px;
            }

            &:hover {
                background: var(--gw-dark-bg-opacity-hover);
            }
        }

        @media screen and (max-width: 425px) {
            &__arrow {
                width: 25px;
                height: 25px;
                align-items: center;
            }
        }

        @media screen and (max-width: 600px) {
            display: none;
        }
    }
</style>
